import { render, staticRenderFns } from "./NoticeView.vue?vue&type=template&id=1f26148e&scoped=true"
import script from "./NoticeView.vue?vue&type=script&lang=js"
export * from "./NoticeView.vue?vue&type=script&lang=js"
import style0 from "./NoticeView.vue?vue&type=style&index=0&id=1f26148e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f26148e",
  null
  
)

export default component.exports